export default __webpack_public_path__ + "static/media/601.da56725b.gif";